import { render } from "./CustomSelectOwner.vue?vue&type=template&id=5785e706"
import script from "./CustomSelectOwner.vue?vue&type=script&lang=js"
export * from "./CustomSelectOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__